import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import * as service from "@/domain/object/files.service";
import * as galleryService from "@/domain/object/gallery.service";
import * as attachmentService from "@/domain/object/attachment.service";

import { clone, guid } from "@/domain/system/utils";

export default {
  data() {
    return {
      saveImageTimerId: undefined,
      saveImageIntervalCounter: 0
    };
  },
  computed: {
    ...mapState({
      lang: state => state.settings.lang,
      previewImgUrl: state => state.thePictureEditor.previewImgUrl,
      cropImg: state => state.thePictureEditor.cropImg,
      indexSelectedFile: state => state.theFileUploader.indexSelectedFile,
      files: state => state.theFileUploader.files,
      widthImgage: state => state.thePictureEditor.widthImgage,
      heightImage: state => state.thePictureEditor.heightImage,
      gallery: state => state.objectComplexValue.galleryList.gallery,
      filesToDelete: state => state.objectComplexValue.filesToDelete,
      attachment: state => state.objectComplexValue.fileList.file
    }),
    ...mapGetters(["getSelectedFile", "getSelectedFile"]),
    fileName() {
      let selectedFile = this.getSelectedFile;
      if (selectedFile) {
        return selectedFile.file.name;
      }
      return "";
    }
  },
  methods: {
    ...mapActions([
      "filePreview",
      "fileSave",
      "fileDelete",
      "fileDescriptionSave",
      "fileCopy",
      "uploadFile"
    ]),
    ...mapMutations([
      "selectFile",
      "setSourceImage",
      "clearPictureEditor",
      "clearFileUploader",
      "setCropMe",
      "setCropImage",
      "setNextFile",
      "initGalleryList",
      "clearObjectComplexValue",
      "appendGalleryObject",
      "resetPreview",
      "setGalleryList",
      "appendFilesToDelete",
      "initFileList",
      "updateFileItem",
      "setRequaredFieldComplexValue",
      "setFilePreview"
    ]),
    imagePreviewSend() {
      if (this.getSelectedFile) {
        this.filePreview({
          lang: this.lang,
          fileName: `${guid()}_${this.getSelectedFile.file.name}`
        });
      }
    },
    clearFilesAll() {
      this.clearPictureEditor();
      this.clearFileUploader();
    },
    clearImageTimer() {
      clearInterval(this.saveImageTimerId);
      this.saveImageTimerId = undefined;
      this.saveImageIntervalCounter = 0;
    },
    async saveImageInterval(obj) {
      if (this.cropImg) {
        this.loading = true;

        let result = await this.fileSave({
          objectId: obj.objectId,
          attributeId: obj.attributeId,
          lang: this.lang,
          fileName: obj.obj.fileName
        });

        if (result && result.id) {
          try {
            if (galleryService.isNewPhotoPreview(obj.obj)) {
              this.resetPreview();
            }

            // Добавление новой записи галереи в хранилище галерей
            this.appendGalleryObject(
              galleryService.getNewGalleryForList(
                obj.obj,
                obj.languages,
                result.url
              )
            );

            // Если добавленная запись имеет порядковый номер выше заведенных, то нужно переопределить номера и пересортировать
            this.setGalleryList(
              galleryService.recalcGalleryOrderNum(
                this.gallery.map(t => clone(t)),
                this.gallery.length - 1
              )
            );

            // Сохраняем галерею в БД
            let descriptionResponse = await this.fileDescriptionSave({
              id: result.id,
              lang: this.lang,
              ...service.prepareToUpdate(this.gallery)
            });

            this.parseResponse(descriptionResponse);

            if (descriptionResponse.id && descriptionResponse.id > 0) {
              this.setSourceImage("");
              this.setCropImage("");

              this.setNextFile();
              this.setImageAsSource();
            }

            this.loading = false;

            if (obj.callback) {
              obj.callback();
            }
          } catch (error) {
            this.loading = false;
            this.errorNotify();
          }
        } else {
          this.loading = false;
          this.errorNotify(result.error);
        }

        this.clearImageTimer();
      } else {
        this.saveImageIntervalCounter++;
        if (this.saveImageIntervalCounter > 15) {
          this.clearImageTimer();
        } else {
          this.saveImageInterval(obj);
        }
      }
    },
    async saveFile(objectId, attributeId, obj, languages, callback) {
      this.setCropMe(true);

      this.saveImageTimerId = setTimeout(this.saveImageInterval, 100, {
        objectId,
        attributeId,
        obj,
        languages,
        callback
      });
    },
    setImageAsSource() {
      if (this.getSelectedFile) {
        this.setSourceImage(this.getSelectedFile.src);
      }
      this.setFilePreview("");
    },
    initSelectedGalleryList(val, requaredField) {
      this.initGalleryList(val);
      this.setRequaredFieldComplexValue(requaredField);
    },
    initSelectedFileList(val, requaredField) {
      this.initFileList(val);
      this.setRequaredFieldComplexValue(requaredField);
    },
    async cancelComplexValueMode() {
      this.clearObjectComplexValue();
    },
    async deleteFiles() {
      this.filesToDelete.forEach(url => {
        this.fileDelete({
          lang: this.lang,
          data: { url }
        });
      });
    },
    async deleteAllObjectFiles(list) {
      list.forEach(url => this.appendFilesToDelete(url));
      await this.deleteFiles();
      this.clearObjectComplexValue();
    },
    async saveEditedAttachment(objectId, attributeId, attributeValueId) {
      let attrValueId = attributeValueId;

      // Загружаем новые файлы на сервер
      for (let i = 0; i < this.attachment.length; i++) {
        if (!this.attachment[i].url) {
          let uploadRes = await this.uploadFile({
            src: this.attachment[i].source,
            fileName: `${this.attachment[i].fileShortName}.${this.attachment[i].fileExt}`,
            objectId,
            attributeId: attributeId,
            lang: this.lang
          });

          if (uploadRes.id && uploadRes.id > 0 && uploadRes.url) {
            if (!attrValueId) {
              attrValueId = uploadRes.id;
            }

            this.updateFileItem({
              guid: this.attachment[i].guid,
              fieldName: "url",
              value: uploadRes.url
            });
          }
        }
      }

      // Обновляем описание атрибута
      let descriptionResponse = await this.fileDescriptionSave({
        id: attrValueId,
        lang: this.lang,
        ...attachmentService.prepareToUpdate(this.attachment)
      });

      this.parseResponse(descriptionResponse);

      this.clearObjectComplexValue();
    },
    async saveEditedGallery(attributeValueId) {
      let descriptionResponse = await this.fileDescriptionSave({
        id: attributeValueId,
        lang: this.lang,
        ...service.prepareToUpdate(this.gallery)
      });

      this.parseResponse(descriptionResponse);

      if (descriptionResponse.id && descriptionResponse.id > 0) {
        await this.deleteFiles();
      }

      this.clearObjectComplexValue();
    },
    changeGalleryRow(url, obj, languages) {
      if (galleryService.isNewPhotoPreview(obj)) {
        this.resetPreview();
      }

      let updatedRow = galleryService.getNewGalleryForList(obj, languages, url);
      let newGallery = this.gallery.map(t => clone(t));
      let index = 0;

      for (index = 0; index < newGallery.length; index++) {
        if (newGallery[index].url === url) {
          newGallery.splice(index, 1, updatedRow);
          break;
        }
      }

      if (index < newGallery.length) {
        // Если добавленная запись имеет порядковый номер выше заведенных, то нужно переопределить номера и пересортировать
        this.setGalleryList(
          galleryService.recalcGalleryOrderNum(newGallery, index)
        );
      }
    },
    async copyFile(
      file,
      object,
      copyObject,
      currentLanguage,
      languages,
      attributeId
    ) {
      return this.fileCopy(
        service.prepareToCopy(file, object.id, attributeId, this.lang)
      )
        .then(resp => {
          if (resp.id !== undefined && resp.id > 0 && resp.url !== undefined) {
            // Добавление скопированной картинки
            let galleryItem = galleryService.getGalleryItemForCopy(
              this.gallery,
              copyObject,
              currentLanguage,
              languages,
              file.url
            );
            galleryItem.url = resp.url;
            this.appendGalleryObject(galleryItem);

            // Если добавленная запись имеет порядковый номер выше заведенных, то нужно переопределить номера и пересортировать
            this.setGalleryList(
              galleryService.recalcGalleryOrderNum(
                this.gallery.map(t => clone(t)),
                this.gallery.length - 1
              )
            );

            return resp.id;
          } else {
            this.parseResponse(resp);
            return false;
          }
        })
        .catch(() => {
          this.errorNotify();
          return false;
        });
    }
  },
  watch: {
    files: function () {
      if (this.files.length > 0 && this.indexSelectedFile === -1) {
        this.selectFile(0);
      }
    },
    indexSelectedFile: function () {
      this.setImageAsSource();
    }
  }
};
